import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumb from "../Components/Breadcrumb";

const sidemenus = [
  {
    title: "FRA Fee Structure",
    url: "/fee-information/fee-structure",
  },
  {
    title: "Online Fee Approval Proposal",
    url: "/fee-information/fee-approval-proposal",
  },
];

export default function FeeInformation(props) {
  const [menuName, setName] = useState(props.pageName);
  const [menuId, setId] = useState(props.pageId);

  useEffect(() => {
    setName(props.pageName);
    setId(props.pageId);
  }, [props.pageName, props.pageId]);

  useEffect(() => {
    // Remove active-menu class from all links first
    const allWithClass = Array.from(document.querySelectorAll(".sideMenu a"));
    allWithClass.forEach((element) => {
      element.classList.remove("active-menu");
    });

    const id = menuId.toString();
    document.getElementById(id)?.setAttribute("class", "active-menu");

    // hide all sections
    sidemenus.forEach((menu) => {
      const divId = menu.title.split(" ").join("");
      document.getElementById(divId)?.classList.add("d-none");
    });

    // show selected section
    const activeDiv = menuName.split(" ").join("");
    document.getElementById(activeDiv)?.classList.remove("d-none");

    window.scrollTo(0, 0);
  }, [menuName, menuId]);

  const handleClick = (event) => {
    setName(event.currentTarget.textContent.trim());
    setId(event.currentTarget.id);

    document
      .querySelectorAll(".sideMenu a")
      .forEach((el) => el.classList.remove("active-menu"));
  };

  return (
    <>
      <Breadcrumb pageTitle={menuName} />

      <div className="container mt-3">
        <div className="row default-padding-bottom">
          {/* Sidebar */}
          <aside className="sideMenu col-lg-3">
            <div className="scroll-div">
              {sidemenus.map((menu, index) => (
                <Link
                  key={index}
                  id={index}
                  to={menu.url}
                  onClick={handleClick}
                >
                  {menu.title}
                </Link>
              ))}
            </div>
          </aside>

          {/* Content */}
          <div className="col-lg-9">
            <div className="px-lg-3 px-1">
              {sidemenus.map((menu, index) => (
                <div
                  key={index}
                  id={menu.title.split(" ").join("")}
                >
                  {props.pageContent}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}



export function FeeInfoStructure() {
  return (
    <>
      <object
        // data="/assets/pdf/InformationGuidelines.pdf"
        data={process.env.PUBLIC_URL + "/assets/pdf/FeeStructure26_27.pdf"}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={process.env.PUBLIC_URL + "/assets/pdf/FeeStructure26_27.pdf"}>
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function OnlineFeeApprovalProposal() {
  return (
    <object
      data={process.env.PUBLIC_URL + "/assets/pdf/FEES REGULATING AUTHORITY - 2026-27.pdf"}
      type="application/pdf"
      width="100%"
      height={800}
    >
      <p>Your web browser doesn't have a PDF plugin.</p>
      <p>
        Instead you can{" "}
        <Link to={process.env.PUBLIC_URL + "/assets/pdf/FEES REGULATING AUTHORITY - 2026-27.pdf"}>
          click here to download the PDF file.
        </Link>
      </p>
    </object>
  );
}
